<script lang="ts" setup>

const { isH5 } = useDevice()

const inquireTypes = [
  { value: 'CKB Choice' },
  { value: '海外ブランド代理運営' },
  { value: '物流ソリューション' },
  { value: 'その他' },
]

const form = useForm({
  items: [
    {
      label: 'お問い合わせ種別', name: 'inquireType', required: true, comp: isH5 ? 'select' : 'radio', props: {
        placeholder: '選択してください'
      }, options: inquireTypes
    },
    {
      label: '問い合わせ内容', name: 'inquireContent', required: true, props: {
        // placeholder: 'something else'
      }
    },
    { label: '会社名or店舗名', name: 'companyName', required: true },
    {
      label: '責任者名or代表者名', name: 'representName', required: true, comp: 'input-group', props: {
        group: [
          { placeholder: '姓' },
          { placeholder: '名' }
        ]
      }
    },
    {
      label: 'フリガナ', name: 'representNameEn', comp: 'input-group', props: {
        group: [
          { placeholder: 'セイ' },
          { placeholder: 'メイ' }
        ]
      }
    },
    { label: 'メールアドレス', name: 'email', required: true },
    { label: '電話番号', name: 'phoneNumber' },
  ],
  init: {
    inquireType: inquireTypes[0].value
  }
})

const contactUs = async () => {
  try {
    const valid = await form.validate()
    console.log(valid)
    const res = await useRequest('/customer/addConcat', { body: JSON.stringify(form.model) })
    ElMessage.success('提出しました')
    form.clear()
  } catch (err) {
    console.log(err)
  }
}

watch(() => form.model, (v) => {
  console.log(v)
}, { deep: true })

const associated = [
  { link: 'https://s.theckb.com', label: 'THE CKB（直行便） 公式サイト' },
  { link: 'https://s.theckb.com/choice', label: 'CKB Choice 公式サイト' },
  { link: 'https://www.sniffgroup.com', label: 'SNIFF GROUP 公式サイト' },
]
</script>

<template>
  <div id="contact">
    <ADevice>
      <el-select class=" !hidden"></el-select>
      <template #h5>
        <MContainer class="py-[48px] flex flex-col">
          <MText size="h1" placement="left" class=" font-[900]">お問い合わせ</MText>
          <div>
            <MText size="h3" placement="left" class=" font-[900] mb-2">お問い合わせフォーム</MText>
            <MText placement="left">＊ は必須項目です</MText>
          </div>
          <AForm class="flex flex-col gap-6 pb-[24px]" v-bind="form" :scroll-to-error="true"
            :scroll-into-view-options="{ block: 'center' }">
            <MButtonLinkP1 @click="contactUs">
              送信
            </MButtonLinkP1>
          </AForm>
          <div>
            <MText class=" mb-[8px] font-black" size="h3" placement="left">
              スムーズな連絡方法
            </MText>
            <MText class=" mb-[16px]" size="md" placement="left">
              ※ 迅速な対応をご希望の方は、お電話でのご連絡がおすすめです。
            </MText>
            <MText size="lg" placement="left">
              <strong class="font-black">電話：</strong> +86 0571 8868203
            </MText>
          </div>
          <MCol class="gap-[16px] mt-[24px]">
            <MText class="font-black" size="h3" placement="left">
              関連リンク
            </MText>
            <MText v-for="v in associated" size="lg" placement="left">
              <ALink :to="v.link">{{ v.label }}</ALink>
            </MText>
          </MCol>
        </MContainer>
      </template>
      <template #pc>
        <AContainer class=" px-[160px] py-[72px] flex flex-col gap-[48px]">
          <AText size="h1" placement="left" class=" font-[900]">お問い合わせ</AText>
          <div class=" flex items-start justify-between">
            <div class=" flex flex-col gap-[24px] w-[672px] form-content">
              <div>
                <MText size="h1" placement="left" class=" mb-[8px]">お問い合わせフォーム</MText>
                <MText placement="left" class=" mb-[8px]">＊ は必須項目です</MText>
              </div>
              <AForm class=" flex flex-col gap-[24px]" v-bind="form" :scroll-to-error="true"
                :scroll-into-view-options="{ block: 'center' }">
                <MButtonLinkP1 class=" w-[240px]" @click="contactUs">
                  送信
                </MButtonLinkP1>
              </AForm>
            </div>
            <MCol class=" gap-[24px]">
              <div>
                <MText class=" mb-[8px] 900" size="h1" placement="left">
                  スムーズな連絡方法
                </MText>
                <MText class=" mb-[8px]" size="md" placement="left">
                  ※ 迅速な対応をご希望の方は、お電話でのご連絡がおすすめです。
                </MText>
                <MText size="lg" placement="left">
                  <div class=" font-[900] mb-[8px]">電話：</div>
                  <MText size="lg" placement="left">+86 0571 8868203</MText>
                </MText>
              </div>
              <div class="with-divide"></div>
              <MCol class=" gap-[24px]">
                <MText class=" font-[900]" size="h1" placement="left">
                  関連リンク
                </MText>
                <MText v-for="v in associated" size="lg" placement="left">
                  <ALink :to="v.link">{{ v.label }}</ALink>
                </MText>
              </MCol>
            </MCol>
          </div>
        </AContainer>
      </template>
    </ADevice>
  </div>
</template>

<style lang="scss" scoped>
#contact {

  :deep(.el-form-item__label) {
    display: inline-flex;
    flex-direction: row-reverse;
    gap: 0.25rem;
    font-size: 16px;
    line-height: 24px;
    height: 24px;
    // color: rgba(0, 0, 0, 0.88);
  }

  :deep(.is-required) {
    .el-form-item__label::before {
      color: inherit;
      content: '＊'
    }
  }

  :deep(.is-error) {
    .el-form-item__label {
      color: rgba(231, 47, 47, 0.758);
    }
  }

  :deep(.el-form-item__error) {
    display: none;
  }

  :deep(.el-radio) {
    --el-radio-input-border-color-hover: #000000A6;

    &.is-checked .el-radio__inner {
      border-color: #000000A6;
      background: rgba(0, 0, 0, 0.88);
    }

    .is-checked+.el-radio__label {
      color: rgba(0, 0, 0, 0.88);

      font-weight: 900;
    }
  }
}
</style>
